import type React from "react"
export function GolfIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 18v-6" />
      <path d="M8 18v-1" />
      <path d="M16 18v-1" />
      <path d="M12 12a4 4 0 0 0-4-4h8a4 4 0 0 0-4 4Z" />
      <path d="M10 16h4" />
      <path d="M8 7a4 4 0 0 1 8 0" />
      <path d="M7 18h10" />
      <path d="M5 22h14" />
    </svg>
  )
}

